import { render } from "./BehaviorAssessment.vue?vue&type=template&id=6c255218"
import script from "./BehaviorAssessment.vue?vue&type=script&lang=js"
export * from "./BehaviorAssessment.vue?vue&type=script&lang=js"

import "./BehaviorAssessment.vue?vue&type=style&index=0&id=6c255218&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__